import { render, staticRenderFns } from "./GerenciaCadastroDiario.vue?vue&type=template&id=638c4988"
import script from "./GerenciaCadastroDiario.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroDiario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports